<script lang="ts">
  export let label: string;
  export let onAction: () => void;
  export let disabled: boolean = false;
  export let busy: boolean = false;

  export let secondaryLabel: string | undefined = undefined;
  export let secondaryOnAction: (() => void) | undefined = undefined;

  export let statusMessages: string[] = [];
</script>

<div class="org-bar org-bar--secondary bottom-action-bar">
  {#if statusMessages}
    {#each statusMessages as statusMessage}
      <span class="status-message">{statusMessage}</span>
    {/each}
  {/if}
  {#if secondaryLabel && secondaryOnAction}
    <button class="org-button org-button--secondary" type="button" on:click={secondaryOnAction}>
      {secondaryLabel}
    </button>
  {/if}
  <button
    class="org-button org-button--primary"
    type="button"
    aria-busy={busy}
    {disabled}
    on:click={onAction}
  >
    {label}
  </button>
</div>

<style>
  .bottom-action-bar {
    background-color: var(--color-surface-tertiary);
    color: var(--color-text-primary);
  }

  .status-message {
    font-style: italic;
  }
</style>
